/* Lumoss v2 — en-tête collant, révélations au défilement */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- en-tête : fond plein une fois défilé ---- */
  var hdr = document.querySelector('.hdr');
  if (hdr) {
    var sync = function () {
      if (window.scrollY > 48) { hdr.classList.add('is-stuck'); }
      else { hdr.classList.remove('is-stuck'); }
    };
    sync();
    window.addEventListener('scroll', sync, { passive: true });
  }

  /* ---- révélations ---- */
  if (reduce || !('IntersectionObserver' in window)) return;

  var sel = [
    '.sec-head',
    '.grid .card',
    '.origin figure', '.origin .panel',
    '.fab .inner > *',
    '.sizes article', '.rule',
    '.faq .inner > *',
    '.pfaq .pf-item', '.pfaq .pf-head',
    '.lg-head', '.lg-tier',
    '.end .wrap > *'
  ].join(', ');

  var nodes = Array.prototype.slice.call(document.querySelectorAll(sel));
  if (!nodes.length) return;

  nodes.forEach(function (n) { n.classList.add('rv'); });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      var i = 0;
      if (el.parentElement) {
        var sibs = Array.prototype.slice.call(el.parentElement.children)
          .filter(function (c) { return c.classList && c.classList.contains('rv'); });
        i = sibs.indexOf(el);
      }
      if (i > 0) el.style.transitionDelay = Math.min(i, 5) * 90 + 'ms';
      el.classList.add('in');
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });

  nodes.forEach(function (n) { io.observe(n); });

  /* filet de sécurité : rien ne doit rester invisible dans l'écran */
  setTimeout(function () {
    nodes.forEach(function (n) {
      if (n.classList.contains('in')) return;
      var r = n.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) n.classList.add('in');
    });
  }, 2200);
})();